import React from "react";
import CommonAccountPanelView from "presentational/account/CommonAccountPanelView";
import TXT from "presentational/common/multinational/TXT";
import PropTypes from "prop-types";

SocialLogInPanel.propTypes = {
  onEmailBtnClick: PropTypes.func.isRequired,
  onGoogleBtnClick: PropTypes.func.isRequired
};

function SocialLogInPanel(props) {
  const { onEmailBtnClick, onGoogleBtnClick } = props;

  return (
    <CommonAccountPanelView
      title={<TXT name="titlePanel_authLogin" />}
      textElement={["authLogin"]}
      onLoginViaEmailBtnClick={onEmailBtnClick}
      onLoginViaGoogleBtnClick={onGoogleBtnClick}
    />
  );
}

export default SocialLogInPanel;
